module.exports = __webpack_public_path__ + "static/media/client.fbd12510.svg";